import React, { useEffect, useState } from 'react'
import { Container } from '../../../../../../components/Container'
import { IconButton, Typography, useTheme } from '@material-ui/core'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import { ChatMessageContent, FeedbackContext } from '../../../types'
import { useLoriState } from '../../../../../../contexts/LoriContext'
import { typographyStyle } from '../../../../../../theme/typographyStyle'

// Map function_call to FeedbackContext
const getFeedbackContext = (
    functionCall: string | null | undefined,
): FeedbackContext => {
    switch (functionCall) {
        case 'create_project':
            return 'create_project'
        case 'create_deadline':
            return 'create_deadline'
        case 'project_plan':
            return 'create_project_plan'
        case 'navigate':
            return 'navigate'
        default:
            return 'create_project' // Default to a valid FeedbackContext
    }
}

interface UserFeedbackProps {
    message: ChatMessageContent
}

export const UserFeedback: React.FC<UserFeedbackProps> = ({ message }) => {
    const theme = useTheme()
    const {
        conversationFeedback,
        addFeedback,
        handleSendMessage,
    } = useLoriState()
    const [feedback, setFeedback] = useState<'positive' | 'negative' | null>(
        null,
    )
    const context = getFeedbackContext(message.function_call)

    useEffect(() => {
        const existingFeedback = conversationFeedback.find(
            (f) => f.message_id === message.id,
        )

        if (existingFeedback) {
            setFeedback(existingFeedback.feedback ? 'positive' : 'negative')
        }
    }, [message.id, conversationFeedback])

    return (
        <Container
            style={{
                flexDirection: 'row',
                alignItems: 'center',
            }}
        >
            <Typography style={{ ...typographyStyle(theme.typography.body2) }}>
                Was this response helpful?
            </Typography>
            <IconButton
                onClick={() => {
                    if (message.id) {
                        addFeedback(true, context, message.id)
                        setFeedback('positive')
                    }
                }}
            >
                <ThumbUpIcon
                    style={{
                        color:
                            feedback === 'positive'
                                ? theme.palette.success.main
                                : 'inherit',
                    }}
                />
            </IconButton>
            <IconButton
                onClick={() => {
                    if (message.id) {
                        addFeedback(false, context, message.id)
                        setFeedback('negative')
                    }
                    handleSendMessage(
                        'I am not happy with those results. Can I contact support.',
                        'system',
                    )
                }}
            >
                <ThumbDownIcon
                    style={{
                        color:
                            feedback === 'negative'
                                ? theme.palette.error.main
                                : 'inherit',
                    }}
                />
            </IconButton>
        </Container>
    )
}
